import requests from '@/utils/request.js'
// 主会场数据
const getVenueData = (pawId, venueType) => new Promise(function (resolve, reject) {
  //this.global.newPawId(正式环境使用此id)
  let deviceData = {
    pawId, //第六届测试库id
    venueType, //会场类型(1:主会场 2:分会场)
  };
  requests.get(`/ops/web/info/venues`, deviceData, ({
    code,
    data
  }) => {
    const value = code == 0 ? data : ''
    resolve(value)
  });
})

export default {
    getVenueData
}



// WEBPACK FOOTER //
// ./src/utils/utils.js